import {Observable} from 'rxjs';

export interface MultiSelectSearchDropdownOption {
  label: string;
  value: string;
}

export abstract class ItemListProvider {
  abstract loadValues(values: string[]): Observable<MultiSelectSearchDropdownOption[]>;
  abstract searchValues(query: string): Observable<MultiSelectSearchDropdownOption[]>;
}
